import { render } from "./AutomationEmptyStateDisconnectedToProvider.vue?vue&type=template&id=2be219a4"
import script from "./AutomationEmptyStateDisconnectedToProvider.vue?vue&type=script&lang=js"
export * from "./AutomationEmptyStateDisconnectedToProvider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__